import React from 'react'
import { BsCheckCircleFill, BsPersonHearts, BsCalendarCheckFill, BsQuestionCircle, BsMenuUp, BsPersonLinesFill,BsChatSquareDots, BsCardChecklist, BsCalendarHeart } from "react-icons/bs";

const HomePage = () => {
  return (
    <div className='home'>
      <section className="top_area">
        <div className="top_wrapper">
          <div className="text_area">
            <h2>‘성별정정툴킷’만 있으면,<br />혼자서도 법적 성별 변경 가능!</h2>
            <p className="desc"><strong>성별정정툴킷</strong>은 <strong>트랜스젠더 인권단체 조각보</strong>의<br />주관 하에 진행된 프로젝트입니다.</p>
          </div>
          <div className="logo_area">
            <img  src={`${process.env.PUBLIC_URL}/img/logo_toolkit_color_onlyimg.png`}
                  className='jogakbo'
                  alt="성별정정툴킷 로고" />
            <img  src={`${process.env.PUBLIC_URL}/img/logo_jogakbo_short.png`}
                  className='jogakbo'
                  alt="트랜스젠더 인권단체 조각보 로고" />
          </div>
        </div>
      </section>
      <div className="bg_area">
        <section className="info_area">
          <div className="info_card">
            <div className="info">
              <div className="icon"><BsCheckCircleFill size='40' color='white' /></div>
              <p className="desc">믿을 수 있는 정보</p>
            </div>
          </div>
          <div className="info_card">
            <div className="info">
              <div className="icon"><BsPersonHearts size='40' color='white' /></div>
              <p className="desc">내게 필요했던 정보</p>
            </div>
          </div>
          <div className="info_card">
            <div className="info">
              <div className="icon"><BsCalendarCheckFill size='40' color='white' /></div>
              <p className="desc">업데이트 되는 정보</p>
            </div>
          </div>
        </section>
        <div className="main_area">
          <section className="usage">
            <h3>성별정정툴킷, 이렇게 활용하세요!</h3>
            <p className="desc">카드를 누르면 해당 페이지로 이동됩니다!</p>
            <div className="box_wrapper">
              <a className="box_area" href='https://gender-toolkit.kr/intro/doineed'>
                <div className="box">
                  <div className="icon"><BsChatSquareDots size='35' /></div>
                  <p>성별이 변경되면 생기는<br />변화를 미리 알고<br />변경에 대해 고민해볼 수 있어요.</p>
                </div>
              </a>
              <a className="box_area" href='https://gender-toolkit.kr/docuprep/docuissue'>
                <div className="box">
                  <div className="icon"><BsCardChecklist size='35'/></div>
                  <p>준비해야 하는 서류를<br />한눈에 확인할 수 있어요.</p>
                </div>
              </a>
              <a className="box_area" href='https://gender-toolkit.kr/docuwrite'>
                <div className="box">
                  <div className="icon"><BsMenuUp size='35' /></div>
                  <p>메뉴를 따라가다 보면<br />어떤 서류를 어떻게 작성해야 하는지<br />알 수 있어요.</p>
                </div>
              </a>
              <a className="box_area" href='https://gender-toolkit.kr/faq'>
                <div className="box">
                  <div className="icon"><BsQuestionCircle size='35'/></div>
                  <p>FAQ를 통해<br />궁금점을 해소할 수 있어요.</p>
                </div>
              </a>
              <a className="box_area" href='https://gender-toolkit.kr/contact'>
                <div className="box">
                  <div className="icon"><BsPersonLinesFill size='35'/></div>
                  <p>문의하면 조각보가<br />답변도 해드려요.</p>
                </div>
              </a>
              <a className="box_area" href='https://www.transgender.or.kr/'>
                <div className="box">
                  <div className="icon"><BsCalendarHeart size='35'/></div>
                  <p>사이트를 활용한 설명회를<br />조각보에서 개최할 예정이에요.</p>
                </div>
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default HomePage
